import React from "react";
import { Box, CircularProgress, Typography } from "@material-ui/core";
import { TEXT } from "Clients/ACCB/ACCBTheme";

const TEXT_STYLE = { fontSize: "0.75rem" };

/**
 * The editor's feedback, for the dialog's action bar (left of the buttons, in
 * place of the hint): recording, transcribing, the transcript arriving or
 * failing, the proofread result, a save confirmation. With nothing to report
 * it shows `fallback` - the hint the bar normally carries.
 *
 * @param {object} props
 * @param {{ state: string, error: string, message: string }} [props.dictation]
 * @param {{ state: string, message: string }} [props.proofread]
 * @param {string} [props.saved] a save confirmation to show
 * @param {React.ReactNode} [props.fallback] shown when there is no status
 */
export default function EditorStatus({ dictation, proofread, saved, fallback = null }) {
  const lines = [];

  if (dictation && dictation.state === "recording") {
    lines.push(
      <Box key="recording" display="flex" alignItems="center" style={{ gap: "0.4rem" }}>
        <span
          style={{
            display: "inline-block",
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            background: "#d32f2f",
            animation: "accb-mic-pulse 1s infinite",
          }}
        />
        <Typography component="span" style={{ ...TEXT_STYLE, color: TEXT.error }}>
          Recording… Click the microphone button again to stop.
        </Typography>
        <style>{`@keyframes accb-mic-pulse { 0%,100%{opacity:1} 50%{opacity:0.2} }`}</style>
      </Box>
    );
  } else if (dictation && dictation.state === "transcribing") {
    lines.push(
      <Box key="transcribing" display="flex" alignItems="center" style={{ gap: "0.4rem" }}>
        <CircularProgress size={12} />
        <Typography component="span" style={{ ...TEXT_STYLE, color: TEXT.secondary }}>
          Transcribing audio…
        </Typography>
      </Box>
    );
  } else if (dictation && dictation.error) {
    lines.push(
      <Typography key="dictation-error" component="span" style={{ ...TEXT_STYLE, color: "#d32f2f" }}>
        {dictation.error}
      </Typography>
    );
  } else if (dictation && dictation.message) {
    lines.push(
      <Typography key="dictation" component="span" style={{ ...TEXT_STYLE, color: "#2e7d32" }}>
        {dictation.message}
      </Typography>
    );
  }

  if (proofread && proofread.message) {
    lines.push(
      <Typography
        key="proofread"
        component="span"
        style={{ ...TEXT_STYLE, color: proofread.state === "error" ? "#d32f2f" : "#2e7d32" }}
      >
        {proofread.message}
      </Typography>
    );
  }

  if (saved) {
    lines.push(
      <Typography key="saved" component="span" style={{ ...TEXT_STYLE, color: "#2e7d32" }}>
        {saved}
      </Typography>
    );
  }

  if (!lines.length) return fallback;
  return (
    <Box display="flex" flexDirection="column" style={{ gap: "2px" }}>
      {lines}
    </Box>
  );
}
